import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  SideBar,
  DivLogo,
  Logo,
  MenuList,
  MenuItem,
  MenuLabel,
} from "./styles";

import itemsMenu from "../../utils/items-side-bar";
import api from "../../services/api";

import { push } from "../../services/navigate";
import { useDispatch, useSelector } from "react-redux";
import { setPatient, setSelectedPatient } from "../../redux/actions/patient.actions";
import { slotByPatient } from "../../redux/actions/schedule.actions";
import { verifyAuth } from "../../redux/actions/utils.actions";


export default function App() {
  const dispatch = useDispatch();

  const [activeRoute, setActiveRoute] = useState("/home");
  const appointments = useSelector((state) => state.schedule.scheduled);

  const user = useSelector((state) => state.userReducer.user);
  const host = window.location.href;

  const [flagScheduling, setFlagScheduling] = useState(false);

  const provider = useSelector((state) => state.userReducer.selectedProvider)

  const hasTelemedicina = useSelector((state) => state.userReducer.telemedicina)
  const hasTelepsicologia = useSelector((state) => state.userReducer.telepsicologia)
  const hasCorporate = useSelector((state) => state.userReducer.corporate)


  function _hasEligibility(product, scheduling) {
    if (scheduling) {
      if (!flagScheduling || provider.validar_tipo_elegibilidade != 0 || provider.produto === process.env.REACT_APP_CORPORATE_PRODUCT) {
        return false;
      }
    }
    switch (product) {
      case "TELEMEDICINA":
        return hasTelemedicina;
      case "TELEPSICOLOGIA":
        return hasTelepsicologia;
      case "CORPORATE":
        return hasCorporate;
      case "ANY":
        return (hasTelemedicina || hasTelepsicologia || hasCorporate);
      default:
        return true;
    }
  }

  const _isScheduling = () => {
    if(flagScheduling && provider.validar_tipo_elegibilidade == 0)
      return true;
    return false;
  }


  function getFlagScheduling() {
    api.get("/config-system").then((result) => {
      const flag = result.data.configSystem[0].scheduling;
      setFlagScheduling(flag);
    });
  }

  useEffect(() => {
    // dispatch(slotByPatient(user));
    getFlagScheduling();
    const activeRoute = host.split("/")[3];
    if (!activeRoute) {
      return setActiveRoute(`/home`);
    }

    setActiveRoute(`/${activeRoute}`);
  }, []);

  function changeRoute(infosRoute) {
    if (infosRoute.needEgilibility && !user.checkElegibility) {
      return;
    }
    dispatch(setSelectedPatient(false));
    dispatch(setPatient({}));
    push(infosRoute.route);
    setActiveRoute(infosRoute.route);
    dispatch(verifyAuth())
  }

  function messageToltip(infosRoute) {
    if (infosRoute.needEgilibility && !user.checkElegibility)
      return "Não foi possível checar a sua elegibilidade, favor verificar se você possui algum contrato!";
  }

  function goToHome() {
    push("/home");
    dispatch(setSelectedPatient(false));
  }

  return (
    <SideBar>
      <DivLogo onClick={() => goToHome()}>
        <Logo src="img/logo-sidebar.png" />
      </DivLogo>

      <MenuList>
        {itemsMenu.map((itemMenu, key) => {
          if (host.includes("telemedicina.einstein.br") && itemMenu.debug)
            return;

          return (
            <MenuItem
              visible={_hasEligibility(itemMenu.product, itemMenu.needScheduling)}
              active={itemMenu.route === activeRoute}
              onClick={() => changeRoute(itemMenu)}
              data-tip={messageToltip(itemMenu)}
            >
              {itemMenu.icon && itemMenu.icon}
              <MenuLabel active={itemMenu.route === activeRoute}>
                {itemMenu.label}
              </MenuLabel>
            </MenuItem>
          );
        })}
      </MenuList>
    </SideBar>
  );
}
